import http from '../_http_v2';

const hash = {
  //default
  list: (m) => { return http.post(`console/wsfinder/hash/list`, m); },
  detail: (m) => { return http.get(`console/wsfinder/hash/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wsfinder/hash`, m); },
  update: (m) => { return http.put(`console/wsfinder/hash`, m); },
  delete: (m) => { return http.delete(`console/wsfinder/hash/${m.id}`); }
}

export default hash

export { hash }